var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6404 18.0537C19.4004 19.4635 18.0306 20.6233 16.6008 20.6233H5.40253C3.96275 20.6233 2.60295 19.4735 2.36299 18.0537L1.03319 10.0949C0.863215 9.11504 1.36314 7.80522 2.14302 7.18532L9.07198 1.63616C10.1318 0.786288 11.8616 0.786288 12.9314 1.64616L19.8603 7.18532C20.6302 7.80522 21.1302 9.11504 20.9702 10.0949L20.3503 13.8143",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit);
export default __webpack_public_path__ + "static/media/unit.633be525ed0476022b42ab69936513b7.svg";
export { ForwardRef as ReactComponent };